import React, { useEffect, useState, useMemo } from 'react';
import Sidebar from '../components/Sidebar';
import './CompanyHistory.css';

const CompanyOverview = () => {
  const [activeSection, setActiveSection] = useState('company-overview');
  
  const sidebarItems = useMemo(() => [
    { name: '회사소개', path: 'company-overview' },
    { name: '연혁', path: 'company-history' },
    { name: '조직도', path: 'organization' },
    { name: '찾아오시는길', path: 'company-location' }
  ], []);

  // 스크롤 스파이 기능
  useEffect(() => {
    const handleScroll = () => {
      const sections = sidebarItems.map(item => item.path);
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop - 200 <= window.scrollY) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sidebarItems]);

  // 해시 URL 처리 (페이지 로드 시 해당 섹션으로 이동)
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setActiveSection(hash);
      setTimeout(() => {
        scrollToSection(hash);
      }, 50);
    }
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  };

  const contactInfo = [
    { icon: '👤', label: '대표자', value: '이미영' },
    { icon: '🏢', label: '본사주소', value: '인천광역시 남동구 남동동로 327 (남동공업단지 43B 9L)' },
    { icon: '📞', label: '본사전화', value: '032-811-0511' },
    { icon: '📠', label: '본사팩스', value: '032-819-0518' },
    { icon: '🏢', label: '부산사무소', value: '부산광역시 해운대구 센텀중앙로 48 609호' },
    { icon: '📞', label: '부산전화', value: '051-503-5431' },
    { icon: '📠', label: '부산팩스', value: '051-504-1364' },
    { icon: '📧', label: '대표메일', value: 'saledept@taibong.com' }
  ];

  const mainProducts = [
    '지역난방 컴팩트 설비 유니트',
    '판형열교환기',
    '판형 코일 열교환기',
    'Air Preheater',
    '팽창기수불리기',
    '순간온수가열기',
    '판형 브레이징 열교환기',
    '판형 스파이럴 열교환기',
    '밀폐형 팽창탱크',
    '스틸 볼밸브'
  ];

  const historyData = {
    "2020's": [
      { year: "2025년 3월", event: "ISO9001/ISO14001/ISO45001 인증 갱신" },
      { year: "2022년 2월", event: "(주)엔솔 포항공장 가동" },
      { year: "2021년 2월", event: "수도용 위생안전기준(KC) 인증 획득" }
    ],
    "2010's": [
      { year: "2017년 4월", event: "강소기업 인증 획득" },
      { year: "2016년 7월", event: "ISO 14001 인증 획득" },
      { year: "2016년 10월", event: "ASME 인증 획득" },
      { year: "2015년 7월", event: "판형열교환기 전열판의 가스켓 특허 취득" },
      { year: "2012년 12월", event: "비전기업 인증" },
      { year: "2011년 5월", event: "신·재생에너지 설비 설치 전문기업 등록" },
      { year: "2011년 6월", event: "엔솔 자회사 설립" },
      { year: "2011년 8월", event: "에너지 절약 전문기업 등록 (ESCO)" }
    ],
    "2000's": [
      { year: "2007년 3월", event: "한국지역난방공사 전국사용자 교육 실시" },
      { year: "2006년 1월", event: "판형열교환기 복층형 구조 특허 취득" },
      { year: "2006년 3월", event: "폐열회수 시스템, 목욕탕 태수의 여과장치 특허 취득" },
      { year: "2005년 5월", event: "중국 심양 태우기전 공장 증축 이전" },
      { year: "2005년 11월", event: "한국수력원자력 공급업체 선정" },
      { year: "2004년 3월", event: "KEPIC(전력산업기술기준) Q Class 인증 획득" },
      { year: "2004년 5월", event: "중국 남정, 북경 태우기전 사무소 개설" },
      { year: "2003년 10월", event: "40,000톤급 Plate 성형용 Press 준공" },
      { year: "2002년 6월", event: "유망 중소기업 선정 (인천광역시)" },
      { year: "2002년 7월", event: "일본 Agent 사무소 개설" },
      { year: "2002년 8월", event: "중국 심양 합자 태우기전 공장 준공, 싱가포르 Agent 사무소 개설" },
      { year: "2001년 5월", event: "수출유망중소기업 선정(중기청)" },
      { year: "2000년 12월", event: "ISO-9001-2000, DNV 인증 획득, 대만 Agent 사무소 개설" }
    ],
    "1990's": [
      { year: "1999년 1월", event: "판형열교환기 Easy-Hook Gasket 구조 개발, 선진 5개국 특허 획득" },
      { year: "1996년 10월", event: "인천 남동공단 확장 이전, 미국 McElroy사로부터 Fin Tube Wrapping Machine 도입" },
      { year: "1993년 2월", event: "Spiral Heat Exchanger 생산라인 가동" }
    ],
    "1980's": [
      { year: "1989년 2월", event: "부천공장 이전" },
      { year: "1989년 5월", event: "노르웨이 선급협회(DNV) 선박용 Lub Oil Cooler Type Approval, 20,000톤급 Plate 성형용 Press 설치" },
      { year: "1986년 12월", event: "Plate Coil 최초 국산화 개발" },
      { year: "1985년 5월", event: "열교환기 설계 전산 프로그램 개발" },
      { year: "1983년 7월", event: "판형열교환기(헤링본 타입) 최초 국산화 성공" },
      { year: "1982년 6월", event: "태봉산업 설립" }
    ]
  };

  // 스크롤 스파이 기능
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['company-overview', 'company-history', 'company-location', 'organization'];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Sidebar 
        category="회사소개" 
        items={sidebarItems} 
        activeSection={activeSection}
        onItemClick={scrollToSection}
      />
      <div className="company-history-page">
        <div className="history-container">
          <h1 className="page-category-title">회사소개</h1>
          {/* 회사소개 섹션 */}
          <section id="company-overview" className="section">
            <h2 className="section-title">회사소개</h2>
            
            <div className="section-container">
              <div className="company-intro-section">
              <div className="company-slogan">
                <h3>40년의 신뢰, 그 이상의 가치</h3>
              </div>
              <p className="intro-text">
                판형열교환기의 국내 최초 국산화를 필두로, 액체-액체, 액체-기체, 기체-기체 등 산업 전반과 건물 냉난방 공정의 가열 및 냉각에 이르는 다양한 열교환 솔루션을 제공해온, 40년 업력의 전문 열교환기 제조사입니다.
              </p>
              
              <div className="company-details">
                <div className="detail-row">
                  <span className="detail-label">대표자:</span>
                  <span className="detail-value">이미영</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">설립일:</span>
                  <span className="detail-value">1982년 6월 10일</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">생산공장 규모:</span>
                  <span className="detail-value">인천 제1공장 (8,473m²), 포항 제2공장 (32,000m²)</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">주요생산품목:</span>
                  <span className="detail-value">판형열교환기, 지역난방용 컴팩트 유니트 및 기타 부속설비</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">본사주소:</span>
                  <span className="detail-value">인천광역시 남동구 남동동로 327 (남동공업단지 43B 9L)</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">본사전화:</span>
                  <span className="detail-value">032-811-0511</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">본사팩스:</span>
                  <span className="detail-value">032-819-0518</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">대표메일:</span>
                  <span className="detail-value">saledept@taibong.com</span>
                </div>
              </div>
              </div>
            </div>
          </section>

          {/* 연혁 섹션 */}
          <section id="company-history" className="section">
            <h2 className="section-title">연혁</h2>
            <div className="section-container">
              <div className="history-timeline">
              {Object.entries(historyData).map(([decade, events]) => (
                <div key={decade} className="timeline-decade">
                  <div className="decade-marker">
                    <span className="decade-text">{decade}</span>
                  </div>
                  <div className="decade-events">
                    {events.map((item, index) => (
                      <div key={index} className="event-item">
                        <span className="event-year">{item.year}</span>
                        <span className="event-description">{item.event}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              </div>
            </div>
          </section>

          {/* 조직도 섹션 */}
          <section id="organization" className="section">
            <h2 className="section-title">조직도</h2>
            <div className="section-container">
              <div className="organization-chart">
                <img src="/jojic.png" alt="태봉산업기술 조직도" />
              </div>
            </div>
          </section>

          {/* 찾아오시는길 섹션 */}
          <section id="company-location" className="section">
            <h2 className="section-title">찾아오시는길</h2>
            <div className="section-container">
              <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '1.1rem', color: '#666' }}>
                태봉산업기술로 찾아오시는 길을 안내합니다.
              </p>
              <div style={{ marginTop: '2rem', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '1rem' }}>본사 및 공장</h3>
                <p><strong>주소:</strong> 인천광역시 남동구 남동로 327(남동공단 43B-9L)</p>
                <div className="desktop-only-map" style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}>
                  <img src="/map1.png" alt="본사 및 공장 위치" style={{ width: '60%', height: '350px', objectFit: 'cover', borderRadius: '8px' }} />
                </div>
              </div>
              <div style={{ marginTop: '2rem', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '1rem' }}>남부사무소</h3>
                <p><strong>주소:</strong> 경상북도 포항시 북구 흥해읍 해안로 968</p>
                <div className="desktop-only-map" style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}>
                  <img src="/map2.png" alt="남부사무소 위치" style={{ width: '60%', height: '350px', objectFit: 'cover', borderRadius: '8px' }} />
                </div>
              </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default CompanyOverview;